import ImageFv from '@assets/images/dx-diagnosis/fv.png';
import ImageFvSp from '@assets/images/dx-diagnosis/fv-sp.webp';
import SvgIconAction from '@assets/images/dx-diagnosis/SvgIconAction';
import SvgIconAnswer from '@assets/images/dx-diagnosis/SvgIconAnswer';
import SvgIconGrow from '@assets/images/dx-diagnosis/SvgIconGrow';
import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import {
  AuthStatusResponse,
  companyAuthStatusApiClient,
} from '@src/api/company/auth/companyAuthStatusApiClient';
import { brandColors } from '@src/assets/colors/brandColors';
import Button from '@src/ui/elements/button/Button';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface ItemProps {
  title: string;
  description: string;
  Icon: React.ReactNode;
}

const Item: React.FC<ItemProps> = ({ title, description, Icon }) => {
  return (
    <li className='flex w-1/3 flex-col items-center gap-[10px] rounded-md border border-solid border-gray-200 px-4 py-6 sm:w-full'>
      <h3 className='text-center'>{title}</h3>
      <div className='rounded-full bg-gray-50'>{Icon}</div>
      <p className='text-center text-sm leading-[1.7]'>{description}</p>
    </li>
  );
};

const DxDiagnosisIntroduction: React.FC = () => {
  const navigate = useNavigate();
  const [loginStatus, setLoginStatus] = useState<AuthStatusResponse>();

  useEffect(() => {
    const fetchLoginStatus = async () => {
      const res = await companyAuthStatusApiClient.status();
      handleApiResponse(res, async (data) => {
        setLoginStatus(data);
      });
    };
    fetchLoginStatus();
  }, []);

  return (
    <main className='px-6 py-12 sm:p-0'>
      <div className='px-9 py-3 sm:px-6 sm:py-10'>
        <img
          className='block h-auto w-full sm:hidden'
          src={ImageFv}
          alt='企業のDX成熟度を診断 DX診断ツール DXステージに応じた最適なサポートでステージアップを実現'
          width={920}
          height={277}
        />
        <img
          className='hidden h-auto w-full sm:block'
          src={ImageFvSp}
          alt='企業のDX成熟度を診断 DX診断ツール DXステージに応じた最適なサポートでステージアップを実現'
          width={327}
          height={387}
        />
        <ul className='mt-10 flex flex-row gap-8 sm:flex-col'>
          <Item
            title='簡単な質問に回答'
            description='5分で完了するシンプルな質問に回答するだけで、企業のDXステージを診断できます。'
            Icon={
              <SvgIconAnswer
                color={brandColors['500']}
                style={{
                  width: '80px',
                  height: '80px',
                }}
              />
            }
          />
          <Item
            title='次のアクションが明確に'
            description='スコアをもとに現在のDXステージを診断し、ステージに応じた最適な取り組みを提案します。'
            Icon={
              <SvgIconAction
                color={brandColors['500']}
                style={{
                  width: '80px',
                  height: '80px',
                }}
              />
            }
          />
          <Item
            title='繰り返し診断して成長を確認'
            description='DXは継続的な取り組みが重要です。定期的に取り組みの成果を把握し、次のアクションを最適化できます。'
            Icon={
              <SvgIconGrow
                color={brandColors['500']}
                style={{
                  width: '80px',
                  height: '80px',
                }}
              />
            }
          />
        </ul>
        {loginStatus !== undefined && !loginStatus.is_login && (
          <div className='mx-auto mt-10 w-[360px] sm:w-full'>
            <Button
              fullWidth
              fullRounded
              onClick={() => {
                window.scrollTo(0, 0);
                navigate('/registration');
              }}
            >
              新規会員登録
            </Button>
            <p className='mb-4 mt-8 text-center text-sm font-semibold'>
              すでにアカウントをお持ちの方
            </p>
            <Button
              fullWidth
              fullRounded
              outline
              onClick={() => {
                window.scrollTo(0, 0);
                navigate('/login');
              }}
            >
              ログイン
            </Button>
          </div>
        )}
        {loginStatus?.is_login && !loginStatus.user?.is_admin && (
          <div className='mt-10 flex items-start justify-center gap-2 md:mt-6 md:flex-col md:items-center'>
            <p className='flex flex-[0_0_auto] translate-y-[2px] items-center border border-solid border-black px-1 text-[10px]'>
              管理者
            </p>
            <p className='text-sm md:text-center'>
              DX診断は管理者向けの機能です。企業管理者にお問い合わせください。
            </p>
          </div>
        )}
      </div>
    </main>
  );
};

export default DxDiagnosisIntroduction;
